/** @jsxImportSource @emotion/react */
import { css, useTheme } from "@emotion/react";
import { useLanguage } from "LanguageContext";
import React, { useState } from "react";
import { useAnalysis } from "../FormComponents/AnalysisResultContext";

type AnalysisTabsProps = {
    analysis?: any;
  };

const Tabs: React.FC<AnalysisTabsProps> = ({
  analysis,
}) => {
  const domainNames = analysis
  ?.flatMap((_item: any) => _item?.domains?.map((_domain: any) => _domain?.domain_name) ?? [])
  .filter(Boolean);
  const [activeTab, setActiveTab] = useState(domainNames?.[0]);
  const theme = useTheme();
  const { language } = useLanguage();
  const { analysisContextResult } = useAnalysis();

const tabContainerStyle = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 0px;
  margin-bottom: 40px;
`;

const tabButtonStyle = css`
  padding: 4px 6px 12px;
  border: none;
  background: transparent;
  border-bottom: 2px solid transparent;
  font-family: ${theme.typography.bodyMedium.fontFamily};
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  color: ${theme.colors.textMedium};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

const activeTabStyle = css`
  color: ${theme.colors.primary};
  border-bottom: 2px solid ${theme.colors.primary};
  font-weight: 600;
`;

const scrollToResultItem = (item: string) => {
    if (typeof document !== "undefined") {
      const element = document.getElementById(item);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        element.click();
      }
    }
  };

  return (
    <div css={tabContainerStyle}>
      {domainNames?.map((tab: string, index: number) => (
        <button
          key={index}
          onClick={() => {setActiveTab(tab); scrollToResultItem(tab)}}
          css={[tabButtonStyle, activeTab === tab && activeTabStyle]}
        >
          {window?.referencesFramework?.[tab]?.[analysisContextResult?.locale_code].title ?? tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
